<p-toast [style]="{marginTop: '80px'}"></p-toast>
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}

<div class="pl-4 pr-4" [formGroup]="form1">
  <p-fieldset styleClass="p-fluid" legend="Property Admin" [toggleable]="true" [collapsed]="true">
    <div class="p-formgrid grid">
      <div class="col-12">
        Global VRBO property actions.
      </div>
      <div class="flex justify-content-end mt-3">
        <button pButton type="button" class="p-button-danger" label="Sync All Properties" (click)="onSyncAllProperties()"></button>
      </div>
    </div>
  </p-fieldset>

  <br>

    <p-fieldset styleClass="p-fluid " legend="Sync Property" [toggleable]="true" [collapsed]="false">
      <div class="p-formgrid grid">
        <div class="col-12">
          Add or update a property to VRBO.
        </div>

        <div class="p-field col-12 mt-6">
          <span class="p-float-label">
            <p-dropdown
              [options]="shortTermRentals"
              formControlName="shortTermRentalId"
              optionLabel="propertyCode"
              optionValue="shortTermRentalId"
              [filter]="true"
              filterBy="propertyCode"
              [showClear]="false"
              placeholder="Select Property">
            </p-dropdown>
            <label for="shortTermRentalId">Select Property</label>
            @for (validation of validationMessages.shortTermRentalId; track validation) {
              <span>
                @if (form1.get('shortTermRentalId')?.hasError(validation.type) && (form1.get('shortTermRentalId')?.dirty || form1.get('shortTermRentalId')?.touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        @if (form1.value.shortTermRentalId) {
          <div class="mt-3">
            <button pButton type="button" label="Sync Property" (click)="onSaveProperty()"></button>
            <div><br><br>
              <a target="_blank" [routerLink]="['/logmans/short-term-rental', 'saveVrboProperty', form1.value.shortTermRentalId]">
                View Logman for shortTermRentalId #{{form1.value.shortTermRentalId}}
              </a>
            </div>
          </div>
        }
      </div>
    </p-fieldset>

    <br><br>

    <h2>Properties</h2>

    <div class="grid mb-3">
      <div class="col-12 md:col-4">
        <span class="p-float-label" style="min-width:260px;">
          <p-dropdown
            [options]="shortTermRentals"
            optionLabel="propertyCode"
            optionValue="shortTermRentalId"
            [(ngModel)]="selectedShortTermRentalId"
            [ngModelOptions]="{standalone:true}"
            [filter]="true"
            filterBy="propertyCode"
            [showClear]="true"
            placeholder="Filter by Property">
          </p-dropdown>
          <label>Filter by Property</label>
        </span>
      </div>
    </div>

    <p-table #dt [value]="filteredRows" [paginator]="true" [rows]="25" [rowsPerPageOptions]="[25,50,100]">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 140px;">
            ShortTermRental ID
            <br>
              <input pInputText type="text" (input)="dt.filter($any($event.target).value, 'shortTermRentalId', 'equals')" placeholder="Filter" style="width:100%;">
            </th>
            <th style="width: 180px;">
              Property
              <br>
                <input pInputText type="text" (input)="dt.filter($any($event.target).value, 'propertyCode', 'contains')" placeholder="Filter" style="width:100%;">
              </th>
              <th style="width: 160px;">
                VRBO Listing Number
                <br>
                  <input pInputText type="text" (input)="dt.filter($any($event.target).value, 'vrboId', 'contains')" placeholder="Filter" style="width:100%;">
                </th>
                <th style="width: 200px;">
                  VRBO STR Id
                  <br>
                    <input pInputText type="text" (input)="dt.filter($any($event.target).value, 'vrboShortTermRentalId', 'contains')" placeholder="Filter" style="width:100%;">
                  </th>
                  <th style="width: 160px;">
                    VRBO Display Id
                    <br>
                      <input pInputText type="text" (input)="dt.filter($any($event.target).value, 'vrboDisplayId', 'contains')" placeholder="Filter" style="width:100%;">
                    </th>
                    <th style="width: 200px;">
                      Last Sync
                      <br>
                        <input pInputText type="text" (input)="dt.filter($any($event.target).value, 'lastSync', 'contains')" placeholder="Filter" style="width:100%;">
                      </th>
                      <th style="width: 160px;">
                        Data Report Status
                        <br>
                          <input pInputText type="text" (input)="dt.filter($any($event.target).value, 'reportStatus', 'contains')" placeholder="Filter" style="width:100%;">
                        </th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row>
                      <tr>
                        <td>{{row.shortTermRentalId}}</td>
                        <td><b>{{row.propertyCode}}</b></td>
                        <td>{{row.vrboId}}</td>
                        <td>{{row.vrboShortTermRentalId}}</td>
                        <td>{{row.vrboDisplayId}}</td>
                        <td>{{row.lastSync | date:'short'}}</td>
                        <td>{{row.reportStatus}}</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>


